export const environment = {
  production: false,
  api: 'https://api-dev.agrotransparencia.com.br',
  frontUrl: 'https://dev.agrotransparencia.com.br',
  gpaUrl: 'https://renovar.agrotransparencia.com.br',
  qualificacaoFornecedoresUrl: 'https://dev-masterboi.qualidadepereciveis.com.br'
};

